export default {
  name: "WrapWithOverlay",
  props: {
    overlay: {
      type: Boolean,
      default: false
    },
    customClass: String
  }
};